export default "__VITE_ASSET__BNTtiWW2__"